/*
 * Filename: login.tsx
 */

import React from 'react';
import { observer } from 'mobx-react';
import './login.css';
import CQ_Logo from '../../assets/images/logo.png';
import { CQAppConstant } from '../../app-constants';
import { IOAuthRequestOptions } from '../../interfaces/IApp.interface';
import { ICQLoginProps } from '../cq-login/ICQLogin.interface';
import { CQAPIService } from '../../services/http-api.service';
import { UserDetailsStore } from '../../store/user-details.store';
import { CQAppStore } from '../../store/cq-app-store';


@observer
class CQLogin extends React.Component<ICQLoginProps>{
  private readonly cqAPIService: CQAPIService;

  constructor(props: ICQLoginProps) {
    super(props);
    this.cqAPIService = new CQAPIService();
  }

  public openSFAuthenticator(oAuthRequestBody: IOAuthRequestOptions, loginUrl: string) {
    this.props.setAccessToken('');
    if (this.props.cookie) {
      this.props.cookie.set(CQAppConstant.LOGIN_URL, loginUrl, { path: CQAppConstant.NAVIGATION.DEFAULT_PATH });
    }
    this.initiateJsForceOauthConnection(oAuthRequestBody);
  }

  public async initiateJsForceOauthConnection(oAuthRequestBody: IOAuthRequestOptions) {
    try {
      await this.cqAPIService.login(oAuthRequestBody).then(async (connection: any) => {
        CQAppStore.loader.setVisibility(true);
        this.props.setAccessToken(connection.accessToken);
        this.props.fetchJWTAccessToken().then(async (jwtToken: string) => {
          if (jwtToken !== '' && this.props.cookie) {
            this.props.cookie.set(CQAppConstant.JWT_KEY, jwtToken, { path: CQAppConstant.NAVIGATION.DEFAULT_PATH });
            this.props.cookie.set(CQAppConstant.INSTANCE_URL, connection.instanceUrl, { path: CQAppConstant.NAVIGATION.DEFAULT_PATH });
            const orgInfo = await this.cqAPIService.getOrgInformation();
            const userInfo = await this.cqAPIService.getUserInformation();
            Promise.all([orgInfo, userInfo]).then((response: { [field: string]: string }[]) => {
                let userDetailsObject: any = {};
                response.forEach((resp: { [field: string]: string }) => {
                    for (const key in resp) {
                        if (resp.hasOwnProperty(key)) {
                            userDetailsObject = resp[key] === null ? { ...userDetailsObject, [key]: '' } : { ...userDetailsObject, [key]: resp[key] };
                        }
                    }
                });

                if (this.props.cookie) {
                    this.props.cookie.set(CQAppConstant.LOGGED_IN_USERNAME, userDetailsObject.username, { path: CQAppConstant.NAVIGATION.DEFAULT_PATH });
                    this.props.cookie.set(CQAppConstant.VERSION_NUMBER, 'v' + userDetailsObject.versionNumber, { path: CQAppConstant.NAVIGATION.DEFAULT_PATH });
                    this.props.cookie.set(CQAppConstant.LOGGED_IN_ORG_NAME_SPACE, userDetailsObject.orgNameSpace, { path: CQAppConstant.NAVIGATION.DEFAULT_PATH });
                    this.props.cookie.set(CQAppConstant.LOGGED_IN_ORG_ID, userDetailsObject.orgId, { path: CQAppConstant.NAVIGATION.DEFAULT_PATH });
                }
                UserDetailsStore.setUserData(userDetailsObject);
                CQAppStore.loader.setVisibility(false);
                this.props.history.push(CQAppConstant.NAVIGATION.TEMPLATES);
            });
          }
        });
      });
    } catch (error : any) {
      CQAppStore.loader.setVisibility(false);
      const errorObj = {
        errorStatus: error.status,
        errorType: CQAppConstant.ERROR_CUSTOM,
        errorMessage: error.error ? error.error : error.message,
        componentName: ''
      };
      CQAppStore.error.dispatchError(errorObj);
    }

  }

  render() {
    if (this.props.cookie && this.props.cookie.get(CQAppConstant.JWT_KEY)) {
      this.props.history.push(CQAppConstant.NAVIGATION.TEMPLATES);
    }
    return (
      <div className="slds-grid slds-grid_vertical slds-grid_vertical-align-center slds-grid_align-center bg-image full-height">
        <div className="slds-grid slds-grid_vertical login-container">
          <img src={CQ_Logo} alt="Logo" className="" />
          <h2 className="slds-text-heading_medium slds-text-align_center slds-m-vertical_large">CQ Lightning Studio, a tool for configuring CQ UI.</h2>
          <div className="slds-button slds-button_brand slds-m-vertical_large"
            onClick={() => this.openSFAuthenticator(CQAppConstant.SF_OAUTH_REQUEST_PROD, CQAppConstant.PRODUCTION_LOGINURL)}
          >Login Production</div>
          <div className="slds-button slds-button_brand slds-m-left_none"
            onClick={() => this.openSFAuthenticator(CQAppConstant.SF_OAUTH_REQUEST_SANDBOX, CQAppConstant.SANDBOX_LOGINURL)}
          >Login Sandbox</div>
        </div>

      </div>
    );
  }
}

export default CQLogin;
